export default {"src":"/_next/static/media/Comprehensive Follow-Up.d2f29682.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};